// extracted by mini-css-extract-plugin
export default {"addToCartControl":"OY-z","giftCard":"PY-z","btnContainer":"QY-z","cartButton":"RY-z","disabled":"SY-z"};